import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './index.css';
// import './assets/styles/no-hover-transforms.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-toastification/dist/index.css';
import Toast, { POSITION } from 'vue-toastification';
// REMOVED: Vuetify and @mdi/font - Migrated to Tailwind CSS and FontAwesome for better performance
import apiInterceptor from './plugins/apiInterceptor';
import navigationGuard from './plugins/navigationGuard';

// Import dark theme and base components
import './styles/tokens/dark-tokens.css';
import './styles/themes/dark-theme.css';
import './styles/z-index.css';
import './styles/mobile-optimizations.css';
import './styles/transition-optimizations.css';
import { registerBaseComponents } from './components/base';

const options = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  hideProgressBar: true,
};

// Vuetify configuration removed - now using Tailwind CSS with custom base components

// VERIFICAÇÃO ESPECIAL: Se estiver na página /blocked, NÃO FAZER NADA
if (window.location.pathname === '/blocked') {
  console.log('Página /blocked detectada. Carregando normalmente sem verificações.');
  // NÃO FAZER ABSOLUTAMENTE NADA - deixar a página carregar normalmente
} 
// Caso contrário, verificar bloqueio normalmente
else {
  // Verificar cookies de bloqueio
  const isBlocked = localStorage.getItem('ipBlocked') === 'true' || 
    document.cookie.split(';').some(function(cookie) {
      return cookie.trim().startsWith('dale_blocked=1');
    });
  
  // Se bloqueado, redirecionar para /blocked
  if (isBlocked) {
    console.warn('IP BLOQUEADO: Redirecionando para /blocked');
    window.location.replace('/blocked');
  }
}

// Criar a aplicação Vue
const app = createApp(App);

// Registrar componentes base globalmente
registerBaseComponents(app);

// Adicionar propriedade global para verificar se IP está bloqueado
app.config.globalProperties.$isIpBlocked = () => {
  return localStorage.getItem('ipBlocked') === 'true';
};

// Mixin global removido para evitar redirecionamentos em loop
// Agora a verificação de bloqueio acontece apenas uma vez no carregamento inicial

// Montar o aplicativo apenas se ainda não houver bloqueio
app
  .use(store)
  .use(Toast, options)
  .use(router)
  .use(apiInterceptor)
  .use(navigationGuard)
  .mount('#app');